// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.loader_wrapper {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  overflow: hidden;\n}\n.loader {\n  -webkit-box-shadow: 0 0 0 1000vh rgba(107, 107, 107, 0.3);\n          box-shadow: 0 0 0 1000vh rgba(107, 107, 107, 0.3);\n  position: absolute;\n  z-index: 999;\n}\n", ""]);
// Exports
module.exports = exports;
